import { useSelector } from 'react-redux';

export const baseurl =
  import.meta.env.VITE_API_URL ||
  'https://api.dev.cha.databuddies.com/django/api/v1';

export const baseurl_utily_api =
  import.meta.env.VITE_UTILITY_API_URL ||
  'https://api.dev.cha.databuddies.com/api/v1';

export const LoggedUser = () => {
  return useSelector((state) => state.user);
};
